const GridBody = ({ tableManager, value }) => {
  return <div style={{ padding: '10px 20px' }}>{value}</div>;
};

export default GridBody;
